import { Navigate, useParams } from 'react-router-dom';

// The separate customer "Screen health" pages were merged into the Screens page and the screen page. Old links keep working.
export const RedirectHealthFleet = () => <Navigate to="/devices/list" replace />;
export const RedirectHealthScreen = () => {
  const { id } = useParams();
  return <Navigate to={`/devices/${id}/show`} replace />;
};
